import classNames from 'classnames';
import React from 'react';
import Tag, { TagProps } from '../../../tag';
import {
  ListItemTitleTagDescriptionSC,
  cssClasses,
} from './list-item-title-tag-description.styled';

interface ITag extends Omit<TagProps, 'children' | 'size'> {
  label: string;
}

interface ListItemTitleTagDescriptionProps
  extends Omit<
    React.DetailedHTMLProps<React.HtmlHTMLAttributes<HTMLDivElement>, HTMLDivElement>,
    'ref' | 'title'
  > {
  title: React.ReactNode;
  tags: ITag[];
  description: React.ReactNode;
}
const ListItemTitleTagDescription = (
  props: ListItemTitleTagDescriptionProps,
  ref?: React.Ref<HTMLDivElement>,
) => {
  const { title, tags, description, className, ...rest } = props;

  return (
    <ListItemTitleTagDescriptionSC
      {...rest}
      ref={ref}
      className={classNames(cssClasses.wrapper, className)}
    >
      <div className={cssClasses.title}>{title}</div>
      <div className={cssClasses.tags}>
        {tags.map(({ label, ...restTag }) => (
          <Tag key={label} {...restTag} size="small" className={cssClasses.tag}>
            {label}
          </Tag>
        ))}
      </div>
      <div className={cssClasses.description}>{description}</div>
    </ListItemTitleTagDescriptionSC>
  );
};

export default React.forwardRef(ListItemTitleTagDescription);
